module.exports = __webpack_public_path__ + "img/rectangle2.f244f1ae.png";